import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { loadingKtvAmplifierDataComponent, loadingOpDataComponent, loadingReserveDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { WriteKtvAmplifierNode, WriteOpNode, WriteReserveNode } from '../../../WriteData/WriteHighwayCommunications';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import { Snackbar } from '@mui/material';


const ReserveEditingDialogNode  = ({ open, onClose, latitude, longitude, canton, area, user, cantonRefresh, hid, entrance}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [reserveData, setReserveData] = useState([]);
  const [oPData, setOpData] = useState([]);
  const [selectedOp, setSelectedOp] = useState(null);
  const [selectedReserveData, setSelectedReserveData] = useState(null);
  const [isVisibleReserve, setIsVisibleReserve] = useState(false);
  const [isVisibleOp, setIsVisibleOp] = useState(false);
  const [commentReserve, setCommentReserve] = useState('');
  const commentTextAreaRefReserve = useRef(null);
  
  

   //загрузка KtvAmplifier
   useEffect(() => {
    const fetchReserveData = async () => {
      try {
        const data = await loadingReserveDataComponent();
        setReserveData(data);
      } catch (error) {
       // console.error("Error in fetchFobData:", error);
      }
    };
    fetchReserveData(); 
  }, []); 

  const handleChangeReserveData = (event) => {
    const selectedReserveData = event.target.value;
    setSelectedReserveData(selectedReserveData);
  };
  
  
  async function reserveDataSave(event) {
     WriteReserveNode(event, selectedReserveData, cantonRefresh,setSelectedReserveData,  hid, entrance, showSnackbar,
                      commentTextAreaRefReserve, setCommentReserve);
  }


  function toggleVisibilityReserve() {
    setIsVisibleReserve(!isVisibleReserve);
  }

  const handleCloseModal = () => {
    setSelectedReserveData(null);
    setIsVisibleReserve(false);
    onClose();
  };

   const handleCommentChangeReserve = (event) => {
    setCommentReserve(event.target.value);
  }

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
        <>
      <div>
      <button onClick={toggleVisibilityReserve} className={isVisibleReserve ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
      {isVisibleReserve ? 'Резерв: скрыть' : 'Резерв: показать'}
    </button>
        {isVisibleReserve && (    
      <div className='divСommunicationsDrawer'>
       
       <img src='./amplifier.png' width='30' height='30' style={{ marginRight: "5px" }} />
      
      <label className='textTitleDrawer'>Резерв</label>
      <hr className="horizontalLineDrawer" />
      <div>
        <select
            className="selectStyleDrawer"
            style={{
              marginBottom: "5px",
              marginTop: "10px",
              marginInlineEnd: "10px"
            }}
            onChange={handleChangeReserveData}
            value={selectedReserveData}
          >
            <option value="null">Выберите резерв</option>

            {reserveData.map((reserve) => (
              <option key={reserve.id} value={reserve.id}>
                {reserve.isUps == 0
                  ? `⚡ ${reserve.upsModel} | 🔋 ${reserve.batteryModel}`
                  : `⚡ ${reserve.upsModel}`}
              </option>
            ))}
          </select>

        <br/>
          <textarea
           className='areaDescriptionDrawer'
           placeholder="Комментарий"
           style={{marginInlineEnd: "10px"}}
           rows={3}
           cols={44}
           value={commentReserve}
           ref={commentTextAreaRefReserve}
           onChange={handleCommentChangeReserve}
         />
       
       
        {/* <hr className="horizontalLineDrawer" style={{ marginTop: "10px" }} />           */}

      </div>
      <div >

        <button onClick={reserveDataSave} style={{marginInlineStart: "0px"}} className='buttonSaveDrawer'>Сохранить</button>
      </div>
    </div>
        )}
    </div>

        </>

    
      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

    

       {/* Snackbar */}
        <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />     
    </Dialog>   
  );
}

export default ReserveEditingDialogNode ;